import baseMarkupSchema from './base-schema';
import breadcrumbListMarkupSchema from './breadcrumb-list';
import collectionPageMarkupSchema from './collection-page';
import organizationMarkupSchema from './organization';
import webSiteMarkupSchema from './web-site';
import webPageMarkupSchema from './web-page';

export {
  baseMarkupSchema,
  breadcrumbListMarkupSchema,
  collectionPageMarkupSchema,
  organizationMarkupSchema,
  webSiteMarkupSchema,
  webPageMarkupSchema,
};
